import { createContext } from 'react';

export const InitializedCommunityContext = createContext<{
  profileInternalId: string | null;
}>({
  profileInternalId: null,
});
